import React, { useState, useEffect, useRef } from 'react';
import {
    IoInformationCircleOutline,
    // IoSearchOutline 
} from "react-icons/io5";
import { RxHamburgerMenu, RxCross2 } from "react-icons/rx";
import { Bell, CollapseIcon } from '../../svgs/index';
// import profile from '../../assets/images/profile.png';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import Accounts from '../shared/accounts';
import Modal from '../shared/modal';
import ModalHeading from '../shared/modal-heading';



const Navbar = ({ toggleSidebar, toggleCollapse, collapsed }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

    // Toggle dropdown
    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    useEffect(() => {
        const data = localStorage.getItem('user');
        if (data) {
            try {
                const parsedUser = JSON.parse(data);
                setUser(parsedUser);
            } catch (err) {
                console.error("Failed to parse user from localStorage:", err);
                setUser(null);
            }
        }
    }, []);


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Handle dropdown item clicks
    const handleDropdownItemClick = (action) => {
        setIsDropdownOpen(false);
        if (action === 'profile') {
            setIsProfileModalOpen(true);
        } else if (action === 'logout') {
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('accountId');
            navigate('/');
        }
    };

    return (
        <div className="flex items-center bg-white border-b z-50 gap-3 justify-between  px-4 w-full py-2">
            {/* Left Part */}
            <div className="flex items-center gap-4">
                {/* Hamburger Menu - only show on mobile */}
                <button
                    onClick={toggleSidebar}
                    className="lg:hidden block text-primary text-2xl"
                >
                    <RxHamburgerMenu />
                </button>

                {/* Collapse Icon - only show on lg+ screens */}
                {
                    collapsed ?
                        ''
                        :
                        <button
                            onClick={toggleCollapse}
                            className="hidden lg:block rotate-180 text-primary text-2xl"
                        >
                            <CollapseIcon />
                        </button>
                }


                {/* Search Bar */}
                {/* <div className="bg-white rounded-full px-3 sm:flex hidden border border-border items-center gap-2 sm:w-60 w-40 lg:w-96 py-1">
                    <IoSearchOutline className="text-gray-500 text-lg" />
                    <input
                        type="text"
                        className="bg-transparent outline-none py-1 w-full text-sm text-gray-700"
                        placeholder="Search"
                    />
                </div> */}
            </div>

            {/* Right Part */}
            <div className="flex items-center w-fit xs:gap-5 gap-3">

                <Link to={'https://yogps.com/help/fleet/'} target='_blank' className='cursor-pointer'>
                    <IoInformationCircleOutline className='text-2xl' />
                </Link>

                {/* <div className="bg-white cursor-pointer ">
                    <Bell />
                </div> */}

                <Accounts />

                <div className="relative" ref={dropdownRef}>
                    <button
                        className="flex items-center gap-1 cursor-pointer"
                        onClick={toggleDropdown}
                    >
                        <h1 className='font-semibold xs:block hidden'>{user?.firstName || 'User'}</h1>
                        <div className='h-9 w-9 flex items-center justify-center p-2 bg-[#7cf1dd] rounded-full font-semibold text-sm text-gray-800'>
                            {user?.firstName?.charAt(0).toUpperCase()}{user?.lastName?.charAt(0).toUpperCase()}
                        </div>

                        {/* <img
                            alt="profile"
                            src={profile}
                            className="xs:h-10 xs:w-10 w-8 h-8 rounded-full"
                        /> */}
                        <ChevronDown className={`text-gray-700 h-5 w-5 transition-all ${isDropdownOpen ? 'rotate-180' : ''}`} />
                    </button>
                    {isDropdownOpen && (
                        <div className="absolute right-0 mt-2 bg-white border border-border rounded-lg shadow-lg z-50">
                            <button
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-activeGray"
                                onClick={() => handleDropdownItemClick('profile')}
                            >
                                Profile
                            </button>
                            <button
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-activeGray"
                                onClick={() => handleDropdownItemClick('logout')}
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Profile Modal */}
            <Modal
                isOpen={isProfileModalOpen}
                onClose={() => setIsProfileModalOpen(false)}
                modalClass="xl:!w-[30%] lg:!w-[35%] md:!w-[45%] sm:!w-[65%] !w-[90%] !px-0"
            >
                <div className="flex flex-col gap-4">
                    <div className="px-4 border-b">
                        <div className="pb-2 relative">
                            <ModalHeading className="text-left">Profile Information</ModalHeading>
                            <button
                                className="hover:scale-105 absolute -top-2 -right-2 bg-white border p-2 rounded-full"
                                onClick={() => setIsProfileModalOpen(false)}
                            >
                                <RxCross2 className="text-xl" />
                            </button>
                        </div>
                    </div>
                    <div className="px-6 py-4">
                        <p className="text-gray-700 text-sm leading-relaxed">
                            Contact <a href="mailto:support@yogps.com" className="text-primary font-semibold hover:underline">support@yogps.com</a> to make changes to your account or profile.
                        </p>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Navbar;